import { colors } from '@components/theme/styles/index';
import { faBuilding } from '@fortawesome/pro-regular-svg-icons';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import ErrorPage from './errorPage';

const NoOrganisations: FC = () => {
  const { t } = useTranslation('common');

  return (
    <ErrorPage
      icon={faBuilding}
      color={colors.warning}
      message={t(
        'error.no_organisations',
        'You do not have access to any organizations. Please contact support.',
      )}
    />
  );
};

export default NoOrganisations;
